module.exports = __webpack_public_path__ + "img/shopping-bag-fill.12a0756a.svg";